import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AssessmentSettingsModalComponent } from "@/components/assessment/assessment-settings-modal/assessment-settings-modal.component";
import { ContextualNavService } from "@/_services/contextual-nav.service";
import { AppDialogService } from "@/_services/app-dialog.service";
import { AssessmentDto } from "@/_models";

@Component({
    selector: "app-create-assessment",
    styleUrls: ["./create-assessment.component.scss"],
    templateUrl: "./create-assessment.component.html",
})
export class CreateAssessmentComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(
        private appDialogService: AppDialogService,
        private contextualNavService: ContextualNavService,
    ) {}

    ngOnInit() {
        this.contextualNavService.onAddAction$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.createNewAssessmentForm());
    }

    createNewAssessmentForm() {
        this.appDialogService.open<void, AssessmentDto | null>(
            AssessmentSettingsModalComponent,
            {
                title: "Report Configuration",
                size: "lg",
                data: null,
            },
        );
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
